import type { AmbassadorTierRate } from '../../api/earnings/ambassador'

type Props = {
  protocolFeeBps: number
  tiers: AmbassadorTierRate[]
}

export default function AmbassadorWhatYouEarn({ protocolFeeBps, tiers }: Props) {
  const protocolFeePct = protocolFeeBps / 100

  return (
    <section className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <h2 className="text-lg font-bold">What you earn</h2>
      <div className="mt-2 text-sm text-white/75">
        Pixeloop takes a <span className="font-semibold text-white">{protocolFeePct.toFixed(2)}%</span> protocol fee on eligible transactions.
        Ambassador rates are a share of that protocol fee, not of total transaction volume.
      </div>
      <div className="mt-1 text-xs text-white/60">Pixeloop protocol fee is 10% on eligible transactions.</div>
      <div className="mt-3 overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="text-left text-white/60">
            <tr>
              <th className="py-2 pr-4">Tier</th>
              <th className="py-2 pr-4">L1 (% of protocol fee)</th>
              <th className="py-2 pr-4">L2 (% of protocol fee)</th>
              <th className="py-2 pr-4">L3 (% of protocol fee)</th>
              <th className="py-2 pr-4">Total (% of protocol fee)</th>
              <th className="py-2 pr-4">~ % of transaction</th>
            </tr>
          </thead>
          <tbody>
            {tiers.map((row) => {
              const totalBps = row.l1_bps + row.l2_bps + row.l3_bps
              const totalProtocolFeePct = totalBps / 100
              const approxTxPct = (protocolFeeBps / 10000) * (totalBps / 100)
              return (
                <tr key={row.tier_level} className="border-t border-white/10">
                  <td className="py-2 pr-4">Tier {row.tier_level}</td>
                  <td className="py-2 pr-4">{(row.l1_bps / 100).toFixed(2)}%</td>
                  <td className="py-2 pr-4">{(row.l2_bps / 100).toFixed(2)}%</td>
                  <td className="py-2 pr-4">{(row.l3_bps / 100).toFixed(2)}%</td>
                  <td className="py-2 pr-4 font-semibold">{totalProtocolFeePct.toFixed(2)}%</td>
                  <td className="py-2 pr-4 text-white/60">~ {approxTxPct.toFixed(2)}%</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      <div className="mt-3 rounded-xl border border-white/10 bg-black/30 p-3 text-xs text-white/65">
        <div className="font-semibold text-white/80">Eligible transactions</div>
        <ul className="mt-1 list-disc pl-4">
          <li>Paid transactions that generate protocol fees</li>
          <li>Settled activity (not failed or reversed)</li>
          <li>Policy-compliant marketplace activity</li>
        </ul>
        <div className="mt-2">Refunds and reversals reduce or reverse ambassador earnings.</div>
      </div>
    </section>
  )
}
